<template>
  <div class="dispatch-map">
    <div class="map-box">
      <div id="container"></div>
      <div class="map-center-box">
        <div class="chatting">
          <van-loading size="14" v-if="getCenterLoading">加载中...</van-loading>
          <span v-else>{{mapCenterInfo.title}}</span>
        </div>
        <van-image
          width="50"
          height="52"
          :src="require(queryParams.type&&queryParams.type=='start'?'/src/assets/image/start-icon.png':'/src/assets/image/end-address-icon.png')"
        />
      </div>
      <!-- 提示框 -->
      <!-- <div class="prompt-dialog-box">
        <div class="iconfont" style="margin-right:10px;font-size:12px;">&#xe638;</div>
        <div>请确认收货地址是否准确，如不准确请拖动地图进行调整</div>
      </div>
      <div :class="{'position-phone':true,'position-phone-active':isPositionPhone}" @click="handlePanToPositionPhone">
        <div class="van-button">

          <div class="dot"></div>
        </div>
      </div> -->
      <div class="tencent-map-footer">
        <div class="tip">
          <div class="tip-icon flex-center">
            <img :src="require('/src/assets/image/icon-assure.png')" style="width: 14px;height: 18px;" alt="">
          </div>
          定位如不准确请拖动地图进行调整
        </div>
        <div class="position" v-if="!isWeiXinLogin() || (pagesQuery.locationPhoneLat && pagesQuery.locationPhoneLng)" @click="handlePanToPositionPhone({ errMsgBool: true })">
          <img :src="require('/src/assets/image/position.png')" style="width: 16px;height: 16px;" alt="" v-if="positionIcon === 'position'">
          <img :src="require('/src/assets/image/position-checked.png')" style="width: 16px;height: 16px;" alt="" v-else-if="positionIcon === 'position-checked'">
          <van-loading size="16" color="#669EE6" v-else-if="positionIcon === 'loading'" />
        </div>
      </div>
    </div>
    <fix-address-info 
      v-if="fixAddressFlag" 
      ref="addressInfo" 
      :mapLoaded="mapLoaded" 
      :isUserType="isUserType" 
      :isSwitchTab="isSwitchTab" 
      :isShowAddr="isShowAddr" 
      :mapCenterInfo="mapCenterInfo" 
      :checkAddressObject="checkAddressObject" 
      :openSearch.sync="openSearch" 
      :getCenterLoading="getCenterLoading" 
      :queryParams.sync="queryParams" 
      @openFixPopup="handleOpenFixaddress"
    />
    <address-info 
      v-else 
      ref="addressInfo" 
      :mapLoaded="mapLoaded" 
      :isUserType="isUserType" 
      :isSwitchTab="isSwitchTab" 
      :isShowAddr="isShowAddr" 
      :mapCenterInfo="mapCenterInfo" 
      :checkAddressObject="checkAddressObject" 
      :openSearch.sync="openSearch" 
      :getCenterLoading="getCenterLoading" 
      :queryParams.sync="queryParams" 
    />
    <search-list 
      ref="searchList" 
      :map="map" 
      :locationPhoneInfo.sync="locationPhoneInfo" 
      :showIdentification.sync="showIdentification" 
      :getCenterLoading.sync="getCenterLoading" 
      :mapCenterInfo.sync="mapCenterInfo" 
      :openSearch.sync="openSearch" 
      :queryParams.sync="queryParams" 
      @openCitySelected="openCitySelected"
      @getMapCenter="getMapCenter" 
      @togglePanend="togglePanend"
    />
    <address-identification 
      :showIdentification.sync="showIdentification" 
      ref="addressIdentification" 
      @confirm="identificationConfirm" 
    />
    <city-selected 
      :locationPhoneInfo="locationPhoneInfo" 
      ref="citySelected" 
      :mapCenterInfo="mapCenterInfo"
      :map="map"
      @getMapCenter="getMapCenter"
      @confirm="handleCityConfirm"
    />
    <my-modal ref="myModal" />
    <fixAddress-status-popup ref="fixAddressStatusPopup" @confirm="handleFixAddressOrder"/>
  </div>
</template>

<script>
import { geocoder , locationIp } from '@/api/dispatch/index.js';
import addressInfo from './components/address-info.vue';
import fixAddressInfo from './components/fix-address-info.vue';
import searchList from './components/search-list.vue';
import addressIdentification from './components/address-identification.vue';
import { Image , Loading , Search, Toast } from 'vant';
import CitySelected from './components/city-selected.vue';
import permission from '@/utils/permission.js'
import Vconsole from 'vconsole';
import myModal from "./components/my-modal.vue";
import fixAddressStatusPopup from '@/view/beecargo/logisticsDetails/components/fixAddress-status-popup.vue';

export default {
  components:{ 
    addressInfo , 
    fixAddressInfo,
    searchList,
    addressIdentification,
    CitySelected,
    myModal,
    fixAddressStatusPopup,
    [Image.name]: Image,
    [Loading.name]: Loading,
    [Search.name]: Search,
   },
   beforeRouteEnter(to,from,next){
    next(vm=>{
      // 用来判断是否是修改卸货地，如果是修改卸货地的，直接跳回应用计算价格，否则就返回上一页
      vm.isSwitchTab = /\/beecargo\/logisticsDetails/.test(from.path)
    });
  },
  data(){
     return {
      map:null,
      mapZoomAntiShakeTimer:null,  //地图缩放防抖计时器
      mapCenterInfo:{},  //当前地图中心数据
      getCenterLoading:false,  //获取中心点loading
      openSearch:false,  //地址搜索栏
      showIdentification:false,  //显示地址识别框
      //手机当前位置
      locationPhoneInfo:{
        province:'',  //省
        city:'',  //市
        district:'',  //区
        detailedAddress:'',  //详细地址
        title:'',  //标题
        latitude:'',
        longitude:'',
      },
      queryParams:{
        id:null,
        province:'',
        city:'',
        district:'',
        detailedAddress:'',
        phoneNumber:'',
        realName:'',
        remark:'',
        title:'',
        latitude:'',
        longitude:'',
        type:1,
        save:false,
        autoCar:0
      },
      mapLoaded:false,  //地图加载完毕(瓦片全部显示)
      watchPositionInfo:{},
      mapPanendSource:'',  //地图平移操作来源
      isSwitchTab:false,//是否是跳转到uniapp应用
      checkAddressObject:{},//存储检查卸货地是否是同一个卸货地
      isShowAddr:false,//是否显示存入地址簿
      isUserType:false,//是否是普通用户进入地图
      positionIcon: "position",
      fixAddressFlag:false,//是否是修改地址进入选择地址
      pagesQuery: {}
    }
  },
  watch:{
    mapCenterInfo:{
      handler(val){
        let newData = this.deepClone(Object.assign(this.queryParams,val));
        newData.address = newData.detailedAddress ? newData.detailedAddress : (newData.address || "");
        this.queryParams = newData;
        return Object.assign(this.queryParams,val);
      },
      deep:true,
      immediate:true
    }
  },
  computed:{
    isPositionPhone(){
      return (this.mapCenterInfo.latitude == this.locationPhoneInfo.latitude && this.mapCenterInfo.longitude == this.locationPhoneInfo.longitude) 
      && (this.locationPhoneInfo.latitude != '22.543099' && this.locationPhoneInfo.longitude != '114.057868');
    }
  },
  beforeCreate(){
    let pagesTital = '';
    let query = this.$route.query;
    // if(query.id) pagesTital = `编辑${query.type==1?'装货地':'卸货地'}`;
    // else pagesTital = `新增${query.type==1?'装货地':'卸货地'}`;
    if(query.id) {
        if(['userAddressBookAdd','userAddressBookEdit'].includes(query.pagesType)) pagesTital = `编辑${query.type=='start'?'装货地':query.type=='end'?'卸货地':'地址'}`;
        else pagesTital = `编辑${query.type=='start'?'装货地':'卸货地'}`;
    }
    else {
        if(['userAddressBookAdd','userAddressBookEdit'].includes(query.pagesType)) pagesTital = `新增${query.type=='start'?'装货地':query.type=='end'?'卸货地':'地址'}`;
        else pagesTital = `新增${query.type=='start'?'装货地':'卸货地'}`;
    }
    document.title = pagesTital;
  },
  created(){
    let vConsole;
    if(process.env.NODE_ENV === 'development') {
      vConsole = new Vconsole();
      window._this = this;
    }
    this.initData();
    // 扩展API是否准备好，如果没有则监听“plusready"事件
    if(!this.isWeiXinLogin()) {
      if (window.plus) {
        console.log("window.plus 存在");
        this.handlePlusReady()
      } else {
        console.log("挂载plusready")
        document.addEventListener('plusready', this.handlePlusReady, false)
      }
    }else{
      this.handlePlusReady();
    }
  },
  mounted(){
    this.createMap()
    .then(()=>this.initMap());

    // this.createGeolocation()
    // .then(()=>this.handleGetLocation)
  },
  beforeDestroy(){
    // this.clearWatch();
  },
  provide(){
    return {
      isWeiXinLogin: () => this.isWeiXinLogin(),
      myModal: options => this.$refs["myModal"].show(options),
      searchHistoryRecordAdd: options => this.$refs.searchList.handleSearchHistoryRecordAdd(options)
    }
  },
  methods:{
    async handlePlusReady(){
      console.log("handlePlusReady")
      await this.createGeolocation();
      let LatLng = {};
      let query = this.$route.query;
      this.isUserType = query.isUser == '0';
      // 是否显示存入地址簿，从地址簿进入的就不显示
      this.isShowAddr = query.isShowAddr && query.isShowAddr == '0';
      if(query.latitude&&query.longitude) LatLng = { lat:query.latitude , lng:query.longitude };
      else if(query.locationPhoneLat&&query.locationPhoneLng) {
        LatLng = { lat:query.locationPhoneLat , lng:query.locationPhoneLng };
      }else LatLng = { lat: '22.543099' , lng: '114.057868' };
      if(!query.latitude || !query.longitude) {
        await this.$sleep(500);
        this.handlePanToPositionPhone().catch(() => this.getMapCenter(LatLng))
      }


      /* 
      if(query.latitude&&query.longitude) LatLng = { lat:query.latitude , lng:query.longitude };
      else if(query.locationPhoneLat&&query.locationPhoneLng) {
        LatLng = { lat:query.locationPhoneLat , lng:query.locationPhoneLng };
      }else LatLng = { lat: '22.543099' , lng: '114.057868' }; */

      /* // 设置手机位置信息
      if(this.$route.query.locationPhoneLng && this.$route.query.locationPhoneLng != '114.057868' && this.$route.query.locationPhoneLat && this.$route.query.locationPhoneLat != '22.543099') {
        console.log("handlePlusReady locationPhoneLng && locationPhoneLat",JSON.stringify({
          locationPhoneLng: this.$route.query.locationPhoneLng,
          locationPhoneLat: this.$route.query.locationPhoneLat
        }));
        // let options = this.$route.query.id?{notSetCenterInfo:true}:{LatLng:{ lat:this.$route.query.locationPhoneLat , lng:this.$route.query.locationPhoneLng }}
        let options = this.$route.query.id?{notSetCenterInfo:true}:{LatLng}
        let result = await this.getMapCenter(options)
        this.locationPhoneInfo = {
          province:result.address_component.province,  //省
          city:result.address_component.city,  //市
          district:result.address_component.district,  //区
          detailedAddress:result.pois[0].address,  //详细地址
          title:result.pois[0].title,  //标题
          latitude:result.location.lat,
          longitude:result.location.lng,
        }
      }else {
        console.log("handlePlusReady 获取定位权限状态",JSON.stringify({
          locationPhoneLng: this.$route.query.locationPhoneLng,
          locationPhoneLat: this.$route.query.locationPhoneLat
        }))
        // 获取定位权限状态
        permission.appPermission({ iosKey:'location', androidKey:'ACCESS_FINE_LOCATION' })
        .then(PermissionResult=>{
          console.log('位置权限成功开启',JSON.stringify(PermissionResult));

          this.handleGetLocation()
          .then(async position => {
            // 设置中心点是手机获取定位的位置
            // this.handlePanToPositionPhone();
            let { result:geocoderResult } = await geocoder({location:`${position.lat},${position.lng}`,get_poi:1,poi_options:'policy=2'});
            this.locationPhoneInfo = {
              province:geocoderResult.address_component.province,  //省
              city:geocoderResult.address_component.city,  //市
              district:geocoderResult.address_component.district,  //区
              detailedAddress:geocoderResult.pois[0].address,  //详细地址
              title:geocoderResult.pois[0].title,  //标题
              latitude:geocoderResult.location.lat,
              longitude:geocoderResult.location.lng,
            }
          }).catch(err=>{
            console.log('位置信息获取失败',JSON.stringify(err));
          })
        })
        .catch(err=>{
          console.log('位置权限开启失败',JSON.stringify(err))
            permission.appPermission({ iosKey:'location', androidKey:'ACCESS_FINE_LOCATION' })
        })
      } */
    },
    /* 城市选择确认
     * 调用搜索列表的搜索功能
     */
    handleCityConfirm(){
      this.$refs['searchList'].handleQuery();
    },
    /* 打开城市选择弹框 */
    openCitySelected(){
      this.$refs['citySelected'].show = true;
    },
    /** 数据初始化 */
    initData(){
      let query = this.$route.query;
      this.pagesQuery = query;
      console.log('数据初始化query: ', JSON.stringify(query));
      this.fixAddressFlag = Boolean(+query.isFixAddress);
      this.checkAddressObject = this.deepClone(query);
      this.queryParams = {
        id:query.id?query.id:null,
        phoneNumber:query.phoneNumber?query.phoneNumber:'',
        realName:query.realName?query.realName:'',
        remark:query.remark?query.remark:'',
        type:query.type?query.type:null,
        pagesType:query.pagesType?query.pagesType:'',
        selected:query.selected&&!isNaN(query.selected)?(+query.selected?true:false):false,
        save:query.save?Boolean(+query.save):false,
        autoCar:query.autoCar?query.autoCar:0,
      };
      if(query.province || query.city || query.latitude || query.longitude) {
        this.mapCenterInfo = {
          province:query.province?query.province:'',
          city:query.city?query.city:'',
          district:query.district?query.district:'',
          detailedAddress:query.detailedAddress?query.detailedAddress:'',
          address:query.detailedAddress?query.detailedAddress:'',
          title:query.title?query.title:'',
          latitude:query.latitude?query.latitude:(query.locationPhoneLat?query.locationPhoneLat:''),
          longitude:query.longitude?query.longitude:(query.locationPhoneLng?query.locationPhoneLng:''),
          adcode:query.adcode?query.adcode:'',
        };
      }
    },
    /** 地址识别确认 */
    identificationConfirm(params){
      Object.assign(this.queryParams,{
        realName:params.realName,
        phoneNumber:params.phoneNumber,
        remark:params.remark
      })
      this.openSearch = true;
      this.$nextTick(()=>{
        this.$refs['searchList'].searchValue = params.detailedAddress.replace(/\s/g,'');
        this.$refs['searchList'].getList();
      })
    },
    async initMap(){
        if(this.map) return ;
        let query = this.$route.query;
        let LatLng = {};
        if(query.latitude&&query.longitude) LatLng = { latitude:query.latitude , longitude:query.longitude };
        else if(query.locationPhoneLat&&query.locationPhoneLng) {
          LatLng = { latitude:query.locationPhoneLat , longitude:query.locationPhoneLng };
        }else LatLng = { latitude: '22.543099' , longitude: '114.057868' };
        var center = new window.TMap.LatLng(LatLng.latitude, LatLng.longitude);
        //初始化地图
        this.map = new window.TMap.Map("container", {
            rotation: 0,//设置地图旋转角度
            pitch: 0, //设置俯仰角度（0~45）
            zoom: 17,//设置地图缩放级别
            center: center,//设置地图中心点坐标
            mapStyleId: 'style1' //设置样式ID
        });
        this.map.on('zoom',this.mapZoom);
        this.map.on('panend',this.mapPanend);
        this.map.on('dragend',this.mapDragend);
        this.map.on('tilesloaded',this.mapTilesloaded);
        this.$refs['searchList'].mountPanend(this.map);
        this.$refs['citySelected'].mountPanend(this.map);
        await this.handleSetLocationPhoneInfo();
        // if(!query.province ||!query.city || !query.latitude || !query.longitude) {
        //   this.openSearch = true;
        // }
        if(this.$route.query.isFixAddress) this.setFixAddressMap(center);
        
    },
    /* 设置手机当前位置信息
     * 当uni跳转过来时带了手机经纬度则根据经纬度逆地址解析设置相关信息
     * 否则需要当 plusReady 时进行相关权限校验再获取位置信息 
     */
    async handleSetLocationPhoneInfo(){
      if(!(this.$route.query.locationPhoneLat && this.$route.query.locationPhoneLng)) return Promise.resolve();
      try {
        let query = this.$route.query;
        if(query.latitude && query.longitude) {
          // 
          /* let mapCenterResult = await this.getMapCenter({
            notSetCenterInfo:true,
            LatLng: {
              lat: query.latitude,
              lng: query.longitude,
            }
          })
          this.mapCenterInfo = {
            province:mapCenterResult.address_component.province,  //省
            city:mapCenterResult.address_component.city,  //市
            district:mapCenterResult.address_component.district,  //区
            detailedAddress:mapCenterResult.pois[0].address,  //详细地址
            title:mapCenterResult.pois[0].title,  //标题
            latitude:mapCenterResult.location.lat,
            longitude:mapCenterResult.location.lng,
          }; */
          this.locationPhoneInfo = {
            province:query.province,  //省
            city:query.city,  //市
            district:query.district,  //区
            detailedAddress:query.detailedAddress,  //详细地址
            title:query.title,  //标题
            latitude:query.latitude,
            longitude:query.longitude,
          };
        }else if(query.locationPhoneLat && query.locationPhoneLng) {
          // 根据经纬度获取手机当前地址信息
          let locationPhoneResult = await this.getMapCenter({
            notSetCenterInfo:true,
            LatLng: {
              lat: query.locationPhoneLat,
              lng: query.locationPhoneLng,
            }
          })
          this.locationPhoneInfo = {
            province:locationPhoneResult.address_component.province,  //省
            city:locationPhoneResult.address_component.city,  //市
            district:locationPhoneResult.address_component.district,  //区
            detailedAddress:locationPhoneResult.pois[0].address,  //详细地址
            title:locationPhoneResult.pois[0].title,  //标题
            latitude:locationPhoneResult.location.lat,
            longitude:locationPhoneResult.location.lng,
          };
          this.mapCenterInfo = this.deepClone(this.locationPhoneInfo);
        }else {
          // 拿默认位置
          let mapCenterResult = await this.getMapCenter({
            notSetCenterInfo:true,
            LatLng: {
              lat: "22.543099",
              lng: "114.057868",
            }
          })
          this.mapCenterInfo = {
            province:mapCenterResult.address_component.province,  //省
            city:mapCenterResult.address_component.city,  //市
            district:mapCenterResult.address_component.district,  //区
            detailedAddress:mapCenterResult.pois[0].address,  //详细地址
            title:mapCenterResult.pois[0].title,  //标题
            latitude:mapCenterResult.location.lat,
            longitude:mapCenterResult.location.lng,
          };
        }

        /* let LatLng = {};
        if(query.latitude&&query.longitude) LatLng = { lat:query.latitude , lng:query.longitude };
        else if(query.locationPhoneLat&&query.locationPhoneLng) {
          LatLng = { lat:query.locationPhoneLat , lng:query.locationPhoneLng };
        }else {
          LatLng = { lat: '22.543099' , lng: '114.057868' };
        }
        let result = await this.getMapCenter({
          notSetCenterInfo:this.$route.query.id?true:false,
          LatLng
        }); */
        
        return Promise.resolve();
      } catch (error) {
        return Promise.resolve();
      }
    },
    // 显示修改地址的半径圆、原装货地
    setFixAddressMap(center){
      //创建圆形覆盖物
      // let MultiCircle = new TMap.MultiCircle({ 
      //   map:this.map,
      //   styles: { // 设置圆形样式
      //     'circle': new TMap.CircleStyle({
      //       'color': 'rgba(255,139,94,0.1)',
      //       'showBorder': true,
      //       'borderColor': '#FF8B5E',
      //       'borderWidth': 1,
      //     }),
      //   },
      //   geometries: [{
      //     styleId: 'circle',
      //     center: center, //圆形中心点坐标 
      //     radius: 1000,	//半径（单位：米）目前限制1公里范围内
      //   }],
      // });
      // 创建原地址
      //创建并初始化MultiMarker
      var markerLayer = new TMap.MultiMarker({
        map: this.map,  //指定地图容器
        //样式定义
        styles: {
          //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
          "myStyle": new TMap.MarkerStyle({ 
              "width": 24,  // 点标记样式宽度（像素）
              "height": 24, // 点标记样式高度（像素）
              "src": require('@/assets/image/map-address-icon.png'),  //图片路径
              //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
              "anchor": { x: 12, y: 12 }  
          }) 
        },
        //点标记数据数组
        geometries: [{
          "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
          "styleId": 'myStyle',  //指定样式id
          "position": center,  //点标记坐标位置
        }]
      });
    },
    // 地图缩放事件
    mapZoom(){
      if(this.mapZoomAntiShakeTimer){
          clearTimeout(this.mapZoomAntiShakeTimer);
          this.mapZoomAntiShakeTimer = null;
      }
      this.mapZoomAntiShakeTimer = setTimeout(()=>this.getMapCenter(),200)
    },
    // 地图拖拽交互结束时触发
    mapDragend(){
      this.getMapCenter();
      this.positionIcon = "position";
    },
    // 地图平移结束
    mapPanend(){
      switch(this.mapPanendSource) {
        case 'positionPhone':
          if(this.map.getZoom()) this.getMapCenter();
          else this.map.zoomTo(17);
          break;
        default:'';
      }
      this.mapPanendSource = '';
    },
    // 瓦片加载完毕
    mapTilesloaded(){
      this.mapLoaded = true;
      this.map.off('tilesloaded',this.mapTilesloaded);
    },
    async getMapCenter(options){
      try {
        if(!(options&&options.notSetCenterInfo)) this.getCenterLoading = true;
        let lat,lng;
        if(options&&options.LatLng) {
          lat = options.LatLng.lat;
          lng = options.LatLng.lng;
        }else {
          let centerData = this.map.getCenter();
          lat = centerData.lat;
          lng = centerData.lng;
        }
        let { result } = await geocoder({location:`${lat},${lng}`,get_poi:1,poi_options:'policy=1'});

        this.mapCenterInfo.adcode = result.ad_info.adcode;
        if(options&&options.notSetCenterInfo) return Promise.resolve(result);
        if(!result.pois.length) {
          this.mapCenterInfo = {
              province:'',  //省
              city:'',  //市
              district:'',  //区
              detailedAddress:'',  //详细地址
              title:'移动以获取位置',  //标题
              latitude:result.location.lat,
              longitude:result.location.lng,
              adcode:result.ad_info.adcode
          };
          return Promise.reject(result)
        }
        this.mapCenterInfo = {
          province:result.address_component.province,  //省
          city:result.address_component.city,  //市
          district:result.address_component.district,  //区
          detailedAddress:result.pois[0].address,  //详细地址
          title:result.pois[0].title,  //标题
          latitude:result.location.lat,
          longitude:result.location.lng,
          adcode:result.ad_info.adcode
        };
        this.getCenterLoading = false;
        return Promise.resolve(result)
      } catch (error) {
          this.getCenterLoading = false;
          return Promise.reject(error);
      }
    },
    /* 移动地图中心点至手机当前位置
     */
    async handlePanToPositionPhone(options){
      /* if(
        (this.locationPhoneInfo.latitude && this.locationPhoneInfo.latitude)
        && (this.locationPhoneInfo.latitude != '22.543099' && this.locationPhoneInfo.longitude != '114.057868')
      ) {
        this.mapPanendSource = 'positionPhone';
        return this.map.panTo(new window.TMap.LatLng(this.locationPhoneInfo.latitude, this.locationPhoneInfo.longitude));
      } */
      if(['loading'].includes(this.positionIcon)) return;
      if(this.isWeiXinLogin()) {
        try {
          let locationPhoneLat = this.$route.query.locationPhoneLat;
          let locationPhoneLng = this.$route.query.locationPhoneLng;
          if(!locationPhoneLat || !locationPhoneLng || locationPhoneLat == 5e-324 || locationPhoneLng == 5e-324) throw new Error("get location error");
          this.positionIcon = "loading";
          let { result:geocoderResult } = await geocoder({location:`${locationPhoneLat},${locationPhoneLng}`,get_poi:1,poi_options:'policy=2'});
          this.locationPhoneInfo = {
            province:geocoderResult.address_component.province,  //省
            city:geocoderResult.address_component.city,  //市
            district:geocoderResult.address_component.district,  //区
            detailedAddress:geocoderResult.pois[0].address,  //详细地址
            title:geocoderResult.pois[0].title,  //标题
            latitude:geocoderResult.location.lat,
            longitude:geocoderResult.location.lng,
          };
          this.mapCenterInfo = {
            province:geocoderResult.address_component.province,  //省
            city:geocoderResult.address_component.city,  //市
            district:geocoderResult.address_component.district,  //区
            detailedAddress:geocoderResult.pois[0].address,  //详细地址
            title:geocoderResult.pois[0].title,  //标题
            latitude:geocoderResult.location.lat,
            longitude:geocoderResult.location.lng,
            adcode:geocoderResult.ad_info.adcode
          };
          this.mapPanendSource = "positionPhone";
          this.positionIcon = "position-checked";
          this.map.panTo(new window.TMap.LatLng(locationPhoneLat, locationPhoneLng));
          return Promise.resolve(geocoderResult);
        } catch (error) {
          console.log("位置信息获取失败",error);
          this.positionIcon = "position";
          this.listLoading = false;
          return Promise.reject(error);
        }
      }else {
        try {
          this.positionIcon = "loading";
          // let PermissionResult = await permission.appPermission({ iosKey:'location', androidKey:'ACCESS_FINE_LOCATION' });
          // console.log('位置权限成功开启',JSON.stringify(PermissionResult));
          let position = await this.handleGetLocation();
          console.log("获取设备位置",JSON.stringify(position));
          if(!position.lat || !position.lng || position.lat == 5e-324 || position.lng == 5e-324 ) {
            throw new Error(position);
          };
          let { result:geocoderResult } = await geocoder({location:`${position.lat},${position.lng}`,get_poi:1,poi_options:'policy=2'});
          this.locationPhoneInfo = {
            province:geocoderResult.address_component.province,  //省
            city:geocoderResult.address_component.city,  //市
            district:geocoderResult.address_component.district,  //区
            detailedAddress:geocoderResult.pois[0].address,  //详细地址
            title:geocoderResult.pois[0].title,  //标题
            latitude:geocoderResult.location.lat,
            longitude:geocoderResult.location.lng,
          };
          this.mapCenterInfo = {
            province:geocoderResult.address_component.province,  //省
            city:geocoderResult.address_component.city,  //市
            district:geocoderResult.address_component.district,  //区
            detailedAddress:geocoderResult.pois[0].address,  //详细地址
            title:geocoderResult.pois[0].title,  //标题
            latitude:geocoderResult.location.lat,
            longitude:geocoderResult.location.lng,
            adcode:geocoderResult.ad_info.adcode
          };
          this.mapPanendSource = 'positionPhone';
          this.positionIcon = "position-checked";
          this.map.panTo(new window.TMap.LatLng(geocoderResult.location.lat, geocoderResult.location.lng));
          return Promise.resolve(geocoderResult);
        } catch (error) {
          console.log('位置信息获取失败',error);
          this.positionIcon = "position";
          this.listLoading = false;
          if(options && options.errMsgBool) {
            this.$dialog.confirm({
              title:'权限提示',
              message:'请在手机中开启定位信息权限',
            }).then(()=>{
              // permission.goSystemAppSetting()
              this.openAppAuthorizeSetting();
            });
          }
          return Promise.reject(error);
        }
      }
      return;
      permission.appPermission({ iosKey:'location', androidKey:'ACCESS_FINE_LOCATION' })
        .then(PermissionResult=>{
          console.log('位置权限成功开启',JSON.stringify(PermissionResult));
          this.handleGetLocation()
          .then(async position => {
            console.log("获取设备位置",JSON.stringify(position));
            if(!position.lat || !position.lng || position.lat == 5e-324 || position.lng == 5e-324 ) {
              console.log("请在手机中开启定位信息权限",position.lat,position.lng)
              this.positionIcon = "position";
              return this.$dialog.confirm({
                title:'权限提示',
                message:'请在手机中开启定位信息权限',
              }).then(()=>permission.goSystemAppSetting());
            }
            let { result:geocoderResult } = await geocoder({location:`${position.lat},${position.lng}`,get_poi:1,poi_options:'policy=2'});
            this.locationPhoneInfo = {
              province:geocoderResult.address_component.province,  //省
              city:geocoderResult.address_component.city,  //市
              district:geocoderResult.address_component.district,  //区
              detailedAddress:geocoderResult.pois[0].address,  //详细地址
              title:geocoderResult.pois[0].title,  //标题
              latitude:geocoderResult.location.lat,
              longitude:geocoderResult.location.lng,
            };
            this.mapPanendSource = 'positionPhone';
            this.positionIcon = "position-checked";
            this.map.panTo(new window.TMap.LatLng(geocoderResult.location.lat, geocoderResult.location.lng));
          }).catch(err=>{
            this.positionIcon = "position";
            console.log('位置信息获取失败',err);
            this.$dialog.confirm({
              title:'权限提示',
              message:'请在手机中开启定位信息权限',
            }).then(()=>permission.goSystemAppSetting())
          })
        }).catch(err=>{
          this.listLoading = false;
          this.positionIcon = "position";
          console.log('位置权限开启失败',err)
          this.$dialog.confirm({
            title:'权限提示',
            message:'请在手机中开启定位信息权限',
          }).then(()=>permission.goSystemAppSetting())
        })
    },
    openAppAuthorizeSetting(){
      window.uni.postMessage({
        data: { pagesType: "openAppAuthorizeSetting" }
      });
    },
    // 打开修改地址确认弹窗
    handleOpenFixaddress(address){
      let query = this.$route.query;
      if(query.city === address.city){
        // 修改地址限制在同一市区内
        this.$refs.fixAddressStatusPopup.init(address,false,{},null,query.mileage,query.payType);
      }else{
        Toast('超出同一市区范围')
      }
    },
    // 确认修改地址
    handleFixAddressOrder(){
      this.$router.go(-1);
    },
    isWeiXinLogin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true; // 微信中打开
      } else {
          return false; // 普通浏览器中打开
      }
    },
    // 开启/关闭地图平移监听事件
    togglePanend(flag){
      if(flag){
        this.map.on('panend',this.mapPanend);
      }else{
        this.map.off('panend',this.mapPanend);
      }
    }
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .mask-style {
      z-index: 9998 !important;
  } 
  ::v-deep .rotate-circle {
    display: none !important;
  }
  ::v-deep .tmap-zoom-control {
    display: none !important;
  }
  ::v-deep .tmap-scale-control {
    display: none !important;
  }
  .dispatch-map {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .map-box {
      flex: 1;
      overflow: hidden;
      position: relative;
      #container {
        width: 100%;
        height: 100%;
      }
      .map-center-box {
        position: absolute;
        left: 50%;
        bottom: 50%;
        transform: translateX(-50%);
        z-index: 9;
        display: flex;
        flex-direction: column;
        align-items: center;
        .chatting {
          box-sizing: border-box;
          // background: url('/src/assets/image/chatting.png') no-repeat left top;
          min-height: 40px;
          overflow: hidden;
          background: url('../../../assets/image/chatting.png') no-repeat left top;
          background-size: 100% 100%;
          padding: 10px 10px 16px 10px;
          font-size: 14px;
          word-break: keep-all;
          text-align: center;
        }
      }
      .prompt-dialog-box {
        // height: 32px;
        display: flex;
        align-items: center;
        font-size: 12px;
        line-height: 32px;
        color: #F1892E;
        background-color: #FFEAD8;
        padding-left: 20px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9997;
        // .bottom {
        //   height: 8px;
        //   position: absolute;
        //   left: 0;
        //   right: 0;
        //   bottom: -8px;
        //   z-index: 9;
        //   background-color: #FFEAD8;
        // }
      }
      .position-phone {
        width: 35px;
        height: 35px;
        position: absolute;
        right: 10px;
        bottom: 50px;
        z-index: 3000;
        background-color: #FFF;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        .van-button {
          width: 20px;
          height: 20px;
          border: 2px solid #333;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          .dot {
            width: 10px;
            height: 10px;
            background-color: #333;
            border-radius: 50%;
          }
        }
      }
      .position-phone-active {
        .van-button {
          border-color: #4776E3;
          .dot {
            background-color: #4776E3;
          }
        }
      }
      .watch-position {
        position: absolute;
        z-index: 9;
        bottom: 50px;
        left: 50%;
        transform: translateX(-50%);
        background-color: #FFF;
      }
      .tencent-map-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        bottom: 8px;
        left: 12px;
        right: 12px;
        z-index: 9999;
        .tip {
          height: 32px;
          box-sizing: border-box;
          font-size: 16px;
          line-height: 28px;
          color: #12A666;
          box-shadow: 2px 2px 4px 1px rgba(8,55,35,0.16);
          background: #F2FCF4;
          border-radius: 8px;
          overflow: hidden;
          display: flex;
          align-items: center;
          padding: 0px 8px 0px 2px;
          font-weight: bold;
          font-family: 'DIN-Medium';
          .tip-icon {
            width: 28px;
            height: 28px;
            border-radius: 7px;
            background: linear-gradient( 180deg, #A9D58B 0%, #6AC6A2 100%);
            margin-right: 8px;
            .iconfont {
              // font-size: 18px;
              color: #FFF;
            }
          }
        }
        .position {
          width: 32px;
          height: 32px;
          border-radius: 8px;
          box-shadow: 2px 2px 4px 1px rgba(8,55,35,0.16);
          background-color: #FFF;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
          &:active {
            background-color: #F8F8F8;
          }
        }
      }
    }
    
  }
  
</style>